/**
 * The one line under the home question while a codebase is being read.
 *
 * A first reader asked "how long should I wait for this message to go
 * away, or is it already ready for use" (2026-09-10): the old line said
 * "the map usually takes a few minutes" and answered neither. This one says
 * what is happening right now, how far along it is, and, always, whether the
 * reader can ask yet. Pure, so the wording is testable without the store.
 */

import type { JobProgressState } from '../refresh/jobProgress';
import { isMapUsable } from '../refresh/jobProgress';

export const ASK_NOW = 'You can ask now; answers get richer as the map fills in.';

export function readingLine(name: string, state: JobProgressState | null): string {
  if (state === null || state.phase === null) {
    return `Reading ${name} · a few minutes for a first map. ${ASK_NOW}`;
  }
  if (isMapUsable(state)) {
    return `The map of ${name} is usable; the rest is being narrated in the background. ${ASK_NOW}`;
  }
  const total = state.planStale;
  const progress =
    total !== null && total > 0 ? ` · ${Math.min(state.passProgress, total)} of ${total}` : '';
  switch (state.phase) {
    case 'pull':
      return `Pulling the latest commits of ${name} · seconds. ${ASK_NOW}`;
    case 'extract':
      return `Reading the code of ${name} · seconds, and free. You can ask as soon as it is read.`;
    case 'narrate':
      return `Writing the map of ${name}${progress} areas · usually a few minutes. ${ASK_NOW}`;
    case 'flows':
      return `Tracing the flows of ${name}${progress} · a minute or two. ${ASK_NOW}`;
  }
}
